import React, { useEffect, Component } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { Navbar } from './components/layout/Navbar';
import { Footer } from './components/layout/Footer';
import { Home } from './pages/Home';
import { SignPage } from './pages/SignPage';
import { initMetaPixel, trackViewContent } from './lib/metaPixel';
class ErrorBoundary extends Component<{
  children: React.ReactNode;
}, {
  hasError: boolean;
}> {
  constructor(props: {
    children: React.ReactNode;
  }) {
    super(props);
    this.state = {
      hasError: false
    };
  }
  static getDerivedStateFromError() {
    return {
      hasError: true
    };
  }
  componentDidCatch(error: Error) {
    // eslint-disable-next-line no-console
    console.error('LOS 12 runtime error:', error);
  }
  render() {
    if (this.state.hasError) {
      return <div className="min-h-screen w-full flex flex-col items-center justify-center bg-cosmic-black text-center px-6" data-id="element-0">
          <h1 className="text-5xl font-serif font-bold text-gold-light mb-4" data-id="element-1">
            LOS 12
          </h1>
          <p className="text-gray-300 mb-6" data-id="element-2">Algo ocurrió al cargar tu reino.</p>
          <button onClick={() => window.location.reload()} className="px-6 py-3 border-2 border-gold-primary text-gold-light rounded-lg" data-id="element-3">
            Reintentar
          </button>
        </div>;
    }
    return this.props.children;
  }
}
function RouteTracker() {
  const location = useLocation();
  useEffect(() => {
    trackViewContent(location.pathname);
  }, [location.pathname]);
  return null;
}
export function App() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <ErrorBoundary data-id="element-4">
      <BrowserRouter data-id="element-5">
        <RouteTracker data-id="element-6" />
        <div className="min-h-screen w-full bg-cosmic-black" data-id="element-7">
          <Navbar data-id="element-8" />
          <main className="pt-16" data-id="element-9">
            <Routes data-id="element-10">
              <Route path="/" element={<Home data-id="element-12" />} data-id="element-11" />
              <Route path="/:signId" element={<SignPage data-id="element-14" />} data-id="element-13" />
            </Routes>
          </main>
          <Footer data-id="element-15" />
        </div>
      </BrowserRouter>
    </ErrorBoundary>;
}